export const SubscriptionStatus = {
    기간만료: "기간만료",
    수동만료: "수동만료",
    구독진행: "구독진행",
    만료예정: "만료예정",
    변경예정: "변경예정",
} as const;
